<ng-container *ngIf="mainSettings?.custom_feedback_link?.length">
  <div class="mb-4 w-100" style="box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12)" role="region" aria-label="Customer feedback">
    <div class="card p-3 h-100 border-0 cms-card-radius w-100 bg-white">
      <ng-container *ngIf="mainSettings.custom_feedback_image">
        <div class="d-flex w-100 justify-content-center mb-3 pt-1">
          <img
            [src]="mainSettings.custom_feedback_image.data.full_url"
            [alt]="mainSettings.custom_feedback_image.title || 'Feedback'"
            class="custom-feedback-image rounded" />
        </div>
      </ng-container>

      <ng-container *ngIf="mainSettings.custom_feedback_message">
        <div class="custom-feedback-message mb-3" [innerHTML]="mainSettings.custom_feedback_message"></div>
      </ng-container>

      <div class="d-flex w-100 justify-content-center pb-1">
        <button type="button" class="de-primary-btn" (click)="openFeedbackLink()" aria-label="Open feedback survey">
          Share Your Feedback
        </button>
      </div>
    </div>
  </div>
</ng-container>
